import { createGetEndpoint } from '@sonar-software/sonar-http';

type DataSecurityApiRequestUsage = {
	max: number;
	remaining: number;
};

export type DataSecurityApiRequestUsageResponse = {
	dailyApiRequests: DataSecurityApiRequestUsage;
};

export const getDataSecurityApiRequestUsage = createGetEndpoint<void, DataSecurityApiRequestUsageResponse>(
	'/api/v3/data-security/organization/api-request-usage'
);
